module.exports = __webpack_public_path__ + "img/dp-sy-zt1.abfbc9e0.png";